import { Crop } from "lucide-react";

import { cn } from "@/lib/utils";

export function DisplayCropBadge({
  className,
  label = "Display crop",
  isDisplayCrop = true,
}: {
  className?: string;
  label?: string;
  isDisplayCrop?: boolean;
}) {
  return (
    <span
      className={cn(
        "pointer-events-none absolute bottom-1.5 right-1.5 inline-flex items-center gap-1 rounded bg-black/75 px-1.5 py-1 text-[10px] font-medium text-white",
        className,
      )}
      title={
        isDisplayCrop
          ? "This browser preview uses object-cover. It is not proof of a pipeline crop."
          : "This browser preview uses object-contain and preserves the full frame."
      }
    >
      <Crop className="size-3" aria-hidden="true" />
      {label}
    </span>
  );
}
